import React from 'react'
import styled, { css } from 'styled-components'

const Chip = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.3;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: background 0.15s, color 0.15s, border-color 0.15s;

  ${({ variant }) => {
    if (variant === 'primary') {
      return css`
        background: #d24724;
        color: #fff;
        border: 1px solid #d24724;
        &:hover { background: #b13a1d; border-color: #b13a1d; }
      `
    }
    if (variant === 'guru') {
      return css`
        background: #fff;
        color: #0e7490;
        border: 1px solid #d4f1f5;
        &:hover { background: #d4f1f5; }
      `
    }
    return css`
      background: #fff;
      color: #d24724;
      border: 1px solid #fbede9;
      &:hover { background: #fbede9; }
    `
  }}

  svg {
    font-size: 14px !important;
    width: 14px;
    height: 14px;
    flex-shrink: 0;
  }
`

const Label = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const WikiActionChip = ({ Icon, icon, label, href, variant, onClick, title, target }) => {
  const handleClick = (e) => {
    if (onClick) {
      e.preventDefault()
      onClick(e)
    }
  }
  const computedTarget = target || (href?.startsWith('/files/upload/') || href?.startsWith('mailto:') ? '_blank' : undefined)
  const rel = computedTarget === '_blank' ? 'noopener noreferrer' : undefined
  return (
    <Chip
      href={href || '#'}
      variant={variant}
      onClick={handleClick}
      title={title || label}
      target={computedTarget}
      rel={rel}
    >
      {Icon && <Icon />}
      {!Icon && icon && <span style={{ fontSize: 11, opacity: 0.85 }}>{icon}</span>}
      <Label>{label}</Label>
    </Chip>
  )
}

export default WikiActionChip
